// hooks/useSpeechRecognition.js
import { useState, useEffect, useRef } from 'react';

const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition || null;

export default function useSpeechRecognition({
  onResult,
  onError,
  continuous = false,
  interimResults = false,
}) {
  const recognitionRef = useRef(null);
  const [isListening, setIsListening] = useState(false);

  useEffect(() => {
    if (!SpeechRecognition) {
      onError?.('Speech Recognition API not supported in this browser.');
      return;
    }

    recognitionRef.current = new SpeechRecognition();
    recognitionRef.current.continuous = continuous;
    recognitionRef.current.interimResults = interimResults;
    recognitionRef.current.lang = 'en-US';

    recognitionRef.current.onresult = (event) => {
      let transcript = '';
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        transcript += event.results[i][0].transcript;
      }
      onResult?.(transcript);
    };

    recognitionRef.current.onerror = (e) => onError?.(e.error);
    recognitionRef.current.onend = () => {
      setIsListening(false);
    };
  }, [onResult, onError, continuous, interimResults]);

  const startListening = () => {
    if (!recognitionRef.current) return;
    recognitionRef.current.start();
    setIsListening(true);
  };

  const stopListening = () => {
    recognitionRef.current?.stop();
    setIsListening(false);
  };

  return { isListening, startListening, stopListening };
}
